<section #elbridgeForm>
    <div>{{ 'ELBRIDGE_REDIRECT_TITLE' | translate }}</div>
</section>
